import { Theme } from '@mui/material';


const Timeline = (theme: Theme) => {
  return {
  };
};

export default Timeline;
